import React, { useState } from "react";
import { toast } from "react-toastify";
import { useLocation } from "react-router-dom";
import { forgotPassword } from "../../services/authService";
import "../../css/forgotpassword.css"; // make sure we merge styles with login

const ForgotPasswordPage = () => {
    const location = useLocation();
    const defaultRole = location.state?.role || "user";
    const [email, setEmail] = useState("");
    const [role, setRole] = useState(defaultRole);
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            await forgotPassword({ email, role });

            toast.success(
                "Reset link sent! Check your email inbox or junk/spam folder."
            );
        } catch (err) {
            toast.error(
                err.response?.data?.error || "Failed to send reset link."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="full-login forgot-password-container">
            <div className="login-home-container">
                <form onSubmit={handleSubmit} className="login-form">
                    <h2>Forgot Password</h2>

                    <div className="login-form-group">
                        <label>Email</label>
                        <input
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className="login-form-group login-select-wrapper">
                        <label>Role</label>
                        <select
                            value={role}
                            onChange={(e) => setRole(e.target.value)}
                        >
                            <option value="user">User</option>
                            <option value="freelancer">Freelancer</option>
                            <option value="business">Business</option>
                        </select>
                        <span className="role-arrow">▾</span>
                    </div>

                    <button type="submit" className="login-button" disabled={loading}>
                        {loading ? "Sending..." : "Send Reset Link"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;